<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <slot name="header">
      <HeaderDefault />
    </slot>

    <div class="flex h-[calc(100vh-4rem)] container mx-auto">
      <!-- Sidebar -->
      <aside class="hidden md:flex md:w-64 md:flex-col fixed inset-y-16">
        <div
          class="flex-1 flex flex-col min-h-0 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700"
        >
          <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
            <slot name="sidebar">
              <nav class="mt-5 flex-1 px-2 space-y-1">
                <NuxtLink
                  v-for="item in defaultNavItems"
                  :key="item.to"
                  :to="item.to"
                  class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                  :class="
                    $route.path === item.to
                      ? 'bg-primary/10 text-primary'
                      : 'text-gray-600 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-700'
                  "
                >
                  <Icon :name="item.icon" class="mr-3 h-5 w-5" />
                  {{ item.name }}
                </NuxtLink>
              </nav>
            </slot>
          </div>
        </div>
      </aside>

      <!-- Mobile Navigation -->
      <div class="md:hidden fixed inset-x-0 bottom-0 z-50">
        <div
          class="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700"
        >
          <slot name="mobile-nav">
            <nav class="flex justify-around">
              <NuxtLink
                v-for="item in defaultMobileNavItems"
                :key="item.to"
                :to="item.to"
                class="group flex flex-col items-center px-2 py-3 text-xs font-medium"
                :class="
                  $route.path === item.to
                    ? 'text-primary'
                    : 'text-gray-600 dark:text-gray-300'
                "
              >
                <Icon :name="item.icon" class="h-6 w-6" />
                <span class="mt-1">{{ item.name }}</span>
              </NuxtLink>
            </nav>
          </slot>
        </div>
      </div>

      <!-- Main Content -->
      <main class="flex-1 md:ml-64 py-6 px-4 sm:px-6 lg:px-8 pb-16 md:pb-6">
        <div class="max-w-7xl mx-auto">
          <slot />
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
const defaultNavItems = [
  {
    name: "Dashboard",
    to: "/dashboard",
    icon: "heroicons:home",
  },
  {
    name: "Add Event",
    to: "/dashboard/events/create",
    icon: "heroicons:calendar",
  },
  {
    name: "Profile",
    to: "/dashboard/profile",
    icon: "heroicons:user",
  },
  {
    name: "Settings",
    to: "/dashboard/settings",
    icon: "heroicons:cog-6-tooth",
  },
];

const defaultMobileNavItems = [
  {
    name: "Home",
    to: "/dashboard",
    icon: "heroicons:home",
  },
  {
    name: "Alerts",
    to: "/dashboard/events",
    icon: "heroicons:bell",
  },
  {
    name: "Events",
    to: "/dashboard/events/create",
    icon: "heroicons:calendar",
  },
  // {
  //   name: "Profile",
  //   to: "/dashboard/speaker-profile",
  //   icon: "heroicons:user",
  // },
];
</script>
